import { defineMessages } from 'react-intl';

export default defineMessages({
    whatTitle: {
        id: 'fnol.wizard.step.im.What',
        defaultMessage: 'What'
    },
    lossType: {
        id: 'fnol.wizard.step.im.Loss Type',
        defaultMessage: 'Loss Type'
    },
    wcWhereTitle: {
        id: 'fnol.wizard.step.im.Where',
        defaultMessage: 'Where'
    },
    wcInjuryTitle: {
        id: 'fnol.wizard.step.im.Injury',
        defaultMessage: 'Injury'
    },
    wcInjuryDetails: {
        id: 'fnol.im.views.injury.Injury Details',
        defaultMessage: 'Injury Details'
    },
    wcSourceDetail: {
        id: 'fnol.im.views.injury.Source Detail',
        defaultMessage: 'Injury Cause/Source Detail'
    },
    wcInjuryType: {
        id: 'fnol.im.views.injury.Injury Type',
        defaultMessage: 'Injury Type'
    },
    wcInjuryTypeDetails: {
        id: 'fnol.im.views.injury.Injury Type Details',
        defaultMessage: 'Injury Type Details'
    },
    wcSelectInjuryType: {
        id: 'fnol.im.views.injury.Select injury type',
        defaultMessage: '-- Select injury type --'
    },
    wcInjuryDescription: {
        id: 'fnol.im.views.injury.Injury Description',
        defaultMessage: 'Injury Description'
    },
    wcInjuryResultDeath: {
        id: 'fnol.im.views.injury.Injury/illness result in death?',
        defaultMessage: 'Injury/illness result in death?'
    },
    wcInjuryWorkTimeLost: {
        id: 'fnol.im.views.injury.Lost time from work?',
        defaultMessage: 'Lost time from work?'
    },
    wcInjuryMedicalTreatment: {
        id: 'fnol.im.views.injury.Medical Treatment',
        defaultMessage: 'Medical Treatment'
    },
    wcInjuryMedicalAttentionRequired: {
        id: 'fnol.im.views.injury.Medical attention required?',
        defaultMessage: 'Medical attention required?'
    },
    wcInjuryExaminationDate: {
        id: 'fnol.im.views.injury.Examination Date',
        defaultMessage: 'Examination Date'
    },
    wcInjuryDoctorFirstName: {
        id: 'fnol.im.views.injury.Doctor\'s_First Name',
        defaultMessage: 'Doctor\'s First Name'
    },
    wcInjuryDoctorLastName: {
        id: 'fnol.im.views.injury.Doctor\'s_Last Name',
        defaultMessage: 'Doctor\'s Last Name'
    },
    wcInjuryDoctorFirstNameKanji: {
        id: 'fnol.im.views.injury.Doctor\'s_First Name Kanji',
        defaultMessage: 'Doctor\'s First Name Kanji'
    },
    wcInjuryDoctorLastNameKanji: {
        id: 'fnol.im.views.injury.Doctor\'s_Last Name Kanji',
        defaultMessage: 'Doctor\'s Last Name Kanji'
    },
    wcInjuryBodyInjuries: {
        id: 'fnol.im.views.injury.Body Injuries',
        defaultMessage: 'Body Injuries'
    },
    wcInjuryAdditionalBodyInjury: {
        id: 'fnol.im.views.injury.Additional body injury?',
        defaultMessage: 'Additional body injury?'
    },
    wcInjuryAddAnotherBodyInjury: {
        id: 'fnol.im.views.injury.Add Another Body Injury',
        defaultMessage: 'Add Another Body Injury'
    },
    wcInjuryBodyArea: {
        id: 'fnol.im.views.injury.Body Area',
        defaultMessage: 'Body Area #{bodyAreaCount}'
    },
    wcInjuryAreaOfBody: {
        id: 'fnol.im.views.injury.Area of Body',
        defaultMessage: 'Area of Body'
    },
    wcInjurySelectAreaOfBody: {
        id: 'fnol.im.views.injury.Select Area of Body',
        defaultMessage: '-- Select Area of Body --'
    },
    wcInjuryBodyPart: {
        id: 'fnol.im.views.injury.Body Part',
        defaultMessage: 'Body Part'
    },
    wcInjurySelectBodyPart: {
        id: 'fnol.im.views.injury.Select Body Part',
        defaultMessage: '-- Select Body Part --'
    },
    wcInjuryBodyPartDescription: {
        id: 'fnol.im.views.injury.Body Part Description',
        defaultMessage: 'Body Part Description'
    },
    wcInjurySelectBodyPartDescription: {
        id: 'fnol.im.views.injury.Select Body Part Description',
        defaultMessage: '-- Select Body Part Description --'
    },
    wcInjurySide: {
        id: 'fnol.im.views.injury.Side',
        defaultMessage: 'Side'
    },
    wcInjurySelectSide: {
        id: 'fnol.im.views.injury.Select Side',
        defaultMessage: '-- Select Side --'
    },
    wcInjuryRemoveBodyInjury: {
        id: 'fnol.im.views.injury.Remove Body Injury',
        defaultMessage: 'Remove Body Injury'
    },
    wcInjuryModalRemoveBodyInjury: {
        id: 'fnol.im.views.injury.Are you sure you want to remove Body Injury #: {bodyPartDetail}?',
        defaultMessage: 'Are you sure you want to remove Body Injury #: {bodyPartDetail}?'
    },
    wcInjuryRemoveButton: {
        id: 'fnol.im.views.injury.Remove',
        defaultMessage: 'Remove'
    },
    wcInjuryOccurredInCourseOfEmployment: {
        id: 'fnol.im.views.injury.Did the injury occur in course of Employment?',
        defaultMessage: 'Did the injury occur in course of Employment?'
    },
    wcCreateDraftClaim: {
        id: 'fnol.im.config.FlowConfig.Creating draft claim...',
        defaultMessage: 'Creating draft claim...'
    },
    wcCreateDraftErrorTitle: {
        id: 'fnol.im.config.FlowConfig.Error creating claim',
        defaultMessage: 'Error creating claim'
    },
    wcCreateDraftErrorMessage: {
        id: 'fnol.im.config.FlowConfig.An error occurred attempting to create a claim.',
        defaultMessage: 'An error occurred attempting to create a claim.'
    },
    describeWhatHappendTitle: {
        id: 'fnol.im.views.what.Describe what happened',
        defaultMessage: 'Describe what happened'
    },
    connectTeamNotice: {
        id: 'fnol.im.views.what.connectTeamNotice',
        defaultMessage: 'If you have any questions about your selection please reach out to our claims team at (855)921-3164. '
    },
    injuryCauseSourceLabel: {
        id: 'fnol.im.views.what.Injury Cause/Source',
        defaultMessage: 'Injury Cause/Source'
    },
    selectInjuryCauseSourceLabel: {
        id: 'fnol.im.views.what.Select Injury Cause/Source',
        defaultMessage: '-- Select Injury Cause/Source --'
    },
    detailCauseOfIncidentLabel: {
        id: 'fnol.im.views.what.Indicate who or what caused the incident, and provide other details that would be helpful.',
        defaultMessage: 'Indicate who or what caused the incident, and provide other details that would be helpful.'
    },
    dateEmployerNotifiedLabel: {
        id: 'fnol.im.views.what.Date Employer Notified',
        defaultMessage: 'Date Employer Notified'
    },
    submitAsReportLabel: {
        id: 'fnol.im.views.what.Submit as report only?',
        defaultMessage: 'Submit as report only?'
    },
    injuredEmployeeLabel: {
        id: 'fnol.im.views.what.Injured employee',
        defaultMessage: 'Injured employee'
    },
    firstNameLabel: {
        id: 'fnol.im.views.what.First Name',
        defaultMessage: 'First Name'
    },
    lastNameLabel: {
        id: 'fnol.im.views.what.Last Name',
        defaultMessage: 'Last Name'
    },
    phoneNumberLabel: {
        id: 'fnol.im.views.what.Phone Number',
        defaultMessage: 'Phone Number'
    },
    socialSecurityNumberLabel: {
        id: 'fnol.im.views.what.Social Security Number',
        defaultMessage: 'Social Security Number'
    },
    dateOfBirthLabel: {
        id: 'fnol.im.views.what.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    genderLabel: {
        id: 'fnol.im.views.what.Gender',
        defaultMessage: 'Gender'
    },
    selectGenderLabel: {
        id: 'fnol.im.views.what.Select Gender',
        defaultMessage: '-- Select Gender --'
    },
    policyLocation: {
        id: 'fnol.im.views.what.Policy Location',
        defaultMessage: 'Policy Location'
    },
    selectPolicyLocation: {
        id: 'fnol.im.views.what.Select Policy Location',
        defaultMessage: '-- Select Policy Location --'
    }
});
